module.exports = __webpack_public_path__ + "img/Character_Shenhe_Thumb.08f8f7db.png";